import makeBulkContext from './makeBulkContext';

export const {
  Provider: BulkUsersActionsContextProvider,
  useContext: useBulkUsersActionsContext,
} = makeBulkContext();
